import { usePageQuery } from 'src/hooks/use-page-query';
import type {
  PrismicArticleQueryVariables,
  PrismicArticlesQueryQuery,
} from 'src/types';
import query from '../query.graphql';

export function useEditorialContentListingPageQuery(
  variables: PrismicArticleQueryVariables
) {
  return usePageQuery<PrismicArticlesQueryQuery>({
    query,
    routeName: 'editorialContentListing',
    variables,
  });
}
